export const convertDateToISOStringWithOffset = (date: Date): string => {
  const millisecondsInMinute = 60 * 1000;

  return new Date(date.getTime() - date.getTimezoneOffset() * millisecondsInMinute).toISOString().split('T')[0];
}
